// The wire schemas of the enquiry intent: the ISA answer and the investment
// objective (SEP-344).
//
// This module holds no explainer copy. The onboarding contract imports it, and
// the web application loads the contract on its first page. The options and
// the firm's explanations stay in `enquiry-intent.ts`, which re-exports these
// names.

import { z } from 'zod';

/**
 * The three states of the ISA question. `not_asked` is the state of an enquiry
 * that never put the question, and it is distinct from `no`.
 */
export const ISA_SELECTION_VALUES = ['not_asked', 'yes', 'no'] as const;
export const isaSelectionSchema = z.enum(ISA_SELECTION_VALUES);
export type IsaSelection = z.infer<typeof isaSelectionSchema>;

/**
 * The ISA answer of a case and the place it came from (SEP-344 item 9). The
 * enquiry gives the first answer. The submitted application and the approved
 * fact find answer later, when the enquiry did not.
 */
export const ISA_INTENT_SOURCES = ['enquiry', 'application', 'fact_find'] as const;
export const isaIntentSchema = z.object({
    selection: isaSelectionSchema,
    source: z.enum(ISA_INTENT_SOURCES),
});
export type IsaIntent = z.infer<typeof isaIntentSchema>;

/** The three objectives the firm offers at the enquiry. */
export const INVESTMENT_OBJECTIVE_VALUES = ['income', 'growth', 'balance'] as const;
export const investmentObjectiveSchema = z.enum(INVESTMENT_OBJECTIVE_VALUES);
export type InvestmentObjective = z.infer<typeof investmentObjectiveSchema>;
